'use client';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { paymentMethodsQueryOptions } from '@/features/orders/presentation/queries/orders.queries';

export const usePaymentMethods = ({ locationIdFallback }: { locationIdFallback?: string } = {}) => {
  const { locationId } = useParams<{ locationId: string }>();

  return useQuery(paymentMethodsQueryOptions(locationIdFallback ?? locationId ?? ''));
};
